import { StatsAdapterInterface } from '../../../stats/adapter.interface';
import { GtmStatsDataEventEmailAlertInterface } from '../data/event-email-alert.interface';

export class GtmStatsAdapterEventEmailAlert implements StatsAdapterInterface {
  /**
   * @inheritDoc
   */
  public getData(): GtmStatsDataEventEmailAlertInterface {
    return {
      event: 'Email Alert',
      eventAction: 'Signup:Finish',
      eventLabel: 'Email Lead',
    };
  }
}
